import React from 'react'
export default function OnboardingSteps({ steps }) {
  return (
    <div className='flex flex-col'>
      {steps.map((step, index) => (
        <div
          key={index}
          ref={step.ref}
          className='flex flex-col gap-5 border-solid border-b border-gray-200 pb-12 mb-12'
        >
          <div className='flex flex-col gap-1'>
            <p className='text-sm font-semibold text-gray-400 m-0'>
              {step.count}
            </p>
            <h4
              id={step.name}
              className='leading-none text-alpha-black font-alpha-family m-0'
            >
              {step.title}
            </h4>
          </div>
          <p
            className='text-base m-0'
            dangerouslySetInnerHTML={{ __html: step.desc }}
          ></p>
          <img src={step.coverPhoto} alt={step.title} className='m-0 w-full' />
          {step.desc2 ? (
            <p
              className='text-base m-0'
              dangerouslySetInnerHTML={{ __html: step.desc2 }}
            ></p>
          ) : null}
          {step.coverPhoto2 ? (
            <img
              src={step.coverPhoto2}
              alt={step.title}
              className='m-0 w-full'
            />
          ) : null}
          {step.desc3 ? (
            <p
              className='text-base m-0'
              dangerouslySetInnerHTML={{ __html: step.desc3 }}
            ></p>
          ) : null}
          {step.coverPhoto3 ? (
            <img
              src={step.coverPhoto3}
              alt={step.title}
              className='m-0 w-full'
            />
          ) : null}
        </div>
      ))}
    </div>
  )
}
